import * as actionTypes from '../../constants/actionTypes';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CROPLIST_ERROR:
      return action.payload;
    case actionTypes.FETCH_CROPLIST_SUCCESS:
      return action.payload.cropList.map(crop => {
        return {
          ...crop,
          label: crop.cropName,
          value: crop.uuid,
        };
      });
    case actionTypes.CLEAR_CROP_INFO:
      return action.payload;
    default:
      return state;
  }
}
